module.exports = __webpack_public_path__ + "static/media/openpay_color.44769d6d.png";